import { withProps } from 'recompose';
import HeaderInner from '../../Header';

const Header = withProps({ product: 'LMNP' })(HeaderInner);

export default Header;
